import React from 'react';
import PropTypes from 'prop-types';

const Step = ({ data, index, startAnimate }) => {
  return (
    <div className="im-step-bar__step">
      <div className={`im-step-bar__step__bar ${index === 2 ? 'im-step-bar__step--active' : ''}`}>
        <div
          id="bar__bar"
          className={`im-step-bar__step__bar__indicator ${index === 2 ? 'im-step-bar__step__bar__indicator--bigger' : ''} ${startAnimate ? `animate__animated animate__fadeInDown animate__delay-${index}s` : ''}`}
        >
          <svg>
            <use xlinkHref={data.svg} />
          </svg>
        </div>
        <div className="im-step-bar__step__bar__inner">
          <div className={`${startAnimate ? `im-step-bar__step__bar__progress animate__animated animate__delay-${index}s` : ''}`} />
          <div className="im-step-bar__step__bar__track" />
        </div>
        <div className="im-step-bar__step__bar__point" />
      </div>
      <div className="im-step-bar__step__content">
        <h3 className="im-step-bar__step__content__heading">
          {data.title}
        </h3>
        {/* <span className="im-step-bar__step__content__description">{data.text}</span> */}
      </div>
    </div>
  );
};

Step.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  startAnimate: PropTypes.bool,
};

export default Step;
